import React, { createContext, useContext } from "react";

const ProfileContext = createContext(null);
const ProfileRefreshContext = createContext(() => {});

export const ProfileProvider = ({ children, profile, refresh }) => {
  return (
    <ProfileContext.Provider value={profile}>
      <ProfileRefreshContext.Provider value={refresh || (() => {})}>
        {children}
      </ProfileRefreshContext.Provider>
    </ProfileContext.Provider>
  );
};

export const useProfile = () => {
  const profile = useContext(ProfileContext);
  if (!profile) {
    throw new Error("useProfile must be used within a ProfileProvider");
  }
  return profile;
};

export const useProfileRefresh = () => useContext(ProfileRefreshContext);
